@if (representativeStateId) {
  <wm-statesummary [resourceId]="representativeStateId" [customLabel]="target.name" [nonInteractive]="true"></wm-statesummary>
}

@if (!representativeStateId) {
  <div class="target-summary">
    <div class="image">
      @if (!screenshotUrl) {
        <fa-icon [icon]="faBox"></fa-icon>
      }
      @if (!!screenshotUrl) {
        <img [src]="screenshotUrl" [alt]="target.name">
      }
    </div>
    <div class="status">No states yet</div>
    <div class="label" [pTooltip]="target.name">{{ target.name || 'Unnamed Test Object' }}</div>
  </div>
}
